import { IPartnerParams } from '@/partners/partnerTypes';
import { EParameters } from '@/utils/setParametersFromParams';

import { getCaseInsensitiveParam } from '../getCaseInsensitiveParam';

import { ISetInitialBorrower } from './ISetInitialBorrower';

export function getInitialBorrowerData(
    partner: IPartnerParams,
    params: URLSearchParams
): ISetInitialBorrower {
    const testDriveFlow = getCaseInsensitiveParam(
        params,
        EParameters.TEST_DRIVE_FLOW
    );
    let testDriveDate = getCaseInsensitiveParam(
        params,
        EParameters.TEST_DRIVE_DATE
    );
    let testDriveTime = getCaseInsensitiveParam(
        params,
        EParameters.TEST_DRIVE_TIME
    );

    // For test drive flow, set default date and time if not provided
    if (
        (testDriveFlow === 'true' || testDriveFlow === '1') &&
        (!testDriveDate || !testDriveTime)
    ) {
        const now = new Date();

        // Set time to next 5-minute interval
        const minutes = now.getMinutes();
        const roundedMinutes = Math.ceil(minutes / 5) * 5;
        now.setMinutes(roundedMinutes);
        now.setSeconds(0);
        now.setMilliseconds(0);

        // If we went past the hour, move to next hour
        if (roundedMinutes >= 60) {
            now.setHours(now.getHours() + 1);
            now.setMinutes(0);
        }

        // Format date as DD-MM-YYYY
        const day = String(now.getDate()).padStart(2, '0');
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const year = now.getFullYear();
        testDriveDate = `${day}-${month}-${year}`;

        // Format time as HH:MM
        const hours = String(now.getHours()).padStart(2, '0');
        const mins = String(now.getMinutes()).padStart(2, '0');
        testDriveTime = `${hours}:${mins}`;
    }

    return {
        leadToken: getCaseInsensitiveParam(params, EParameters.LEAD_TOKEN),
        testDriveDate,
        testDriveTime,
    };
}
